import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Inject X-Park-Id header from localStorage on every request
api.interceptors.request.use((config) => {
  const pid = localStorage.getItem("pd:current_park_id");
  if (pid) {
    config.headers = config.headers || {};
    config.headers["X-Park-Id"] = pid;
  }
  return config;
});

export function setCurrentParkId(id) {
  if (id) localStorage.setItem("pd:current_park_id", id);
  else localStorage.removeItem("pd:current_park_id");
}

export function getCurrentParkId() {
  return localStorage.getItem("pd:current_park_id") || "";
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
